import { render, staticRenderFns } from "./ModulesListScreen.vue?vue&type=template&id=52cd7017&"
import script from "./ModulesListScreen.vue?vue&type=script&lang=js&"
export * from "./ModulesListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports